import { render, staticRenderFns } from "./OsInputDatePicker.vue?vue&type=template&id=0f0c5a8f&scoped=true"
import script from "./OsInputDatePicker.vue?vue&type=script&lang=ts"
export * from "./OsInputDatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c5a8f",
  null
  
)

export default component.exports